<script lang="ts">
  // Five stars filled to `value` (0-5), for training status.
  export let value: number
  export let size = 30
  export let color = 'currentColor'
  export let emptyOpacity = 0.22

  const uid = Math.random().toString(36).slice(2, 8)
  const STAR = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'
</script>

<span class="xr-stars" style="gap: {size * 0.12}px;">
  {#each [0, 1, 2, 3, 4] as i}
    {@const fill = Math.max(0, Math.min(1, value - i))}
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <clipPath id="s-{uid}-{i}"><rect x="0" y="0" width={24 * fill} height="24" /></clipPath>
      </defs>
      <path d={STAR} fill="currentColor" fill-opacity={emptyOpacity} />
      {#if fill > 0}
        <path d={STAR} style="fill: {color}" clip-path="url(#s-{uid}-{i})" />
      {/if}
    </svg>
  {/each}
</span>

<style>
  .xr-stars {
    display: inline-flex;
    align-items: center;
  }
  svg {
    display: block;
  }
</style>
